import { useState } from "react";
import { Navigate, useNavigate } from "react-router";
import { useMe } from "@/shared/api/auth";
import { errorMessage } from "@/shared/api/client";
import { isMember, useJoinProject, useProjects } from "@/shared/api/projects";
import { Button } from "@/shared/ui/button";
import { PageTitle } from "@/shared/ui/page-header";
import { ErrorNote } from "@/shared/ui/state";
import { projectPath, projectUi, type Answers } from "@/core/projects-ui";

/** Csatlakozás meglévő fiókkal: csak a projekt kérdései — a globális nyilatkozatokat
 *  nem kérjük újra (rendszerterv 6.). */
export function JoinPage({ project }: { project: string }) {
  const { data: me } = useMe();
  const { data: projects } = useProjects();
  const ui = projectUi(project);
  const navigate = useNavigate();
  const join = useJoinProject(project);
  const [answers, setAnswers] = useState<Answers>({});

  const info = (projects ?? []).find((p) => p.slug === project);
  if (me && isMember(me, project)) return <Navigate to={projectPath(project)} replace />;

  const valid = !ui || ui.isValid(answers);

  return (
    <div className="mx-auto flex w-full max-w-md flex-col gap-6 px-5 pb-10 pt-8">
      <div className="flex flex-col gap-2">
        <PageTitle>{ui?.joinTitle ?? "Csatlakozás"}</PageTitle>
        <p className="text-[15px] leading-[1.5] text-ink-soft">
          {ui?.joinLead ?? info?.lead ?? ""}
        </p>
      </div>

      {info && !info.registration_open ? (
        <p className="rounded-lg border border-line bg-gray px-4 py-3 text-[14px] text-ink-soft">
          Ehhez az alkalmazáshoz most nem lehet csatlakozni.
        </p>
      ) : (
        <>
          {ui && <ui.Fields answers={answers} onChange={setAnswers} />}
          {join.isError && <ErrorNote>{errorMessage(join.error)}</ErrorNote>}
          <Button
            size="lg"
            block
            disabled={!valid || join.isPending}
            onClick={() =>
              join.mutate(answers, {
                onSuccess: () => navigate(projectPath(project), { replace: true }),
              })
            }
          >
            {join.isPending ? "Csatlakozás…" : "Csatlakozom"}
          </Button>
        </>
      )}

      <button
        type="button"
        onClick={() => navigate("/app")}
        className="text-[13px] font-semibold text-gold-text"
      >
        Vissza az alkalmazásokhoz
      </button>
    </div>
  );
}
